import { Controller } from "@hotwired/stimulus"

// FD-297/U4: live HH:MM clock for the home greeting (Plane shows a ticking time).
// Renders the viewer's local time and refreshes each minute. The server renders an
// initial value so there's no empty flash before connect().
export default class extends Controller {
  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 30_000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    this.element.textContent = new Date().toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
  }
}
